export default [
  {
    path: '/liaoning',
    name: "liaoning",
    component: () => import('@/views/liaoning/start.vue'),
    children: [
      // {
      //   path: 'flow',
      //   name: "liaoningFlow",
      //   component: () => import('@/views/liaoning/flow.vue'),
      //   meta: {
      //     title: '辽宁移动用户专享'
      //   }
      // },
      {
        path: 'singleflow',
        name: "liaoningSingleFlow",
        component: () => import('@/views/liaoning/singleFlow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'confirmFlow',
        name: "liaoningConfirmFlow",
        component: () => import('@/views/liaoning/confirmFlow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'success',
        name: "liaoningFlowSuccess",
        component: () => import('@/views/liaoning/success.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'commonSuccess',
        name: "liaoningFlowCommonSuccess",
        component: () => import('@/views/liaoning/commonSuccess.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'videoflow',
        name: "lnVideoflow",
        component: () => import('@/views/liaoning/videoflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'flowplus',
        name: "lnFlowplus",
        component: () => import('@/views/liaoning/flowplus.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'flowplusdata',
        name: "lnFlowplusData",
        component: () => import('@/views/liaoning/flowplusdata.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'confirmSingleFlow',
        name: "lnConfirmSingleFlow",
        component: () => import('@/views/liaoning/confirmSingleFlow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'newflow',
        name: "lnNewFlow",
        component: () => import('@/views/liaoning/flow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'wsflow',
        name: "lnWSFlow",
        component: () => import('@/views/liaoning/flow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'aflow',
        name: "lnAFlow",
        component: () => import('@/views/liaoning/aflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'mtflow',
        name: "lnMTFlow",
        component: () => import('@/views/liaoning/mtflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'minimumActivity',
        name: "lnMinimumActivity",
        component: () => import('@/views/liaoning/minimumActivity.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'darkflow',
        name: "lnDarkFlow",
        component: () => import('@/views/liaoning/darkflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'darkgrownflow',
        name: "lnDarkgrownflow",
        component: () => import('@/views/liaoning/darkgrownflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      },
      {
        path: 'aprflow',
        name: "lnAprflow",
        component: () => import('@/views/liaoning/aprflow.vue'),
        meta: {
          title: '辽宁移动用户专享'
        }
      }
      // {
      //   path: 'bflow',
      //   name: "lnBFlow",
      //   component: () => import('@/views/liaoning/bflow.vue'),
      //   meta: {
      //     title: '辽宁移动用户专享'
      //   }
      // }
    ]
  }
]